<template>
    <div class="header-filter">
        <div class="container">
            <div class="header-buttons">
                <div class="type-buttons">
                    <button type="button"
                            @click="changeType('rent')"
                            :class="{'--active': type==='rent'}">{{ $t('Аренда') }}
                    </button>
                    <button type="button"
                            @click="changeType('transfer')"
                            :class="{'--active': type==='transfer'}">{{ $t('Трансфер') }}
                    </button>
                </div>
                <button :disabled="type==='transfer'" type="button" data-bs-toggle="modal" data-bs-target="#filterModal"
                        class="filter-button">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_134_227)">
                            <path
                                d="M5.14166 15.4999C5.31383 15.012 5.63311 14.5895 6.05549 14.2906C6.47787 13.9917 6.98256 13.8312 7.49999 13.8312C8.01742 13.8312 8.52211 13.9917 8.94449 14.2906C9.36687 14.5895 9.68616 15.012 9.85832 15.4999H18.3333V17.1666H9.85832C9.68616 17.6545 9.36687 18.0771 8.94449 18.3759C8.52211 18.6748 8.01742 18.8353 7.49999 18.8353C6.98256 18.8353 6.47787 18.6748 6.05549 18.3759C5.63311 18.0771 5.31383 17.6545 5.14166 17.1666H1.66666V15.4999H5.14166ZM10.1417 9.66659C10.3138 9.17865 10.6331 8.75612 11.0555 8.45725C11.4779 8.15838 11.9826 7.99788 12.5 7.99788C13.0174 7.99788 13.5221 8.15838 13.9445 8.45725C14.3669 8.75612 14.6862 9.17865 14.8583 9.66659H18.3333V11.3333H14.8583C14.6862 11.8212 14.3669 12.2437 13.9445 12.5426C13.5221 12.8415 13.0174 13.002 12.5 13.002C11.9826 13.002 11.4779 12.8415 11.0555 12.5426C10.6331 12.2437 10.3138 11.8212 10.1417 11.3333H1.66666V9.66659H10.1417ZM5.14166 3.83326C5.31383 3.34532 5.63311 2.92279 6.05549 2.62392C6.47787 2.32505 6.98256 2.16455 7.49999 2.16455C8.01742 2.16455 8.52211 2.32505 8.94449 2.62392C9.36687 2.92279 9.68616 3.34532 9.85832 3.83326H18.3333V5.49993H9.85832C9.68616 5.98787 9.36687 6.4104 8.94449 6.70927C8.52211 7.00814 8.01742 7.16864 7.49999 7.16864C6.98256 7.16864 6.47787 7.00814 6.05549 6.70927C5.63311 6.4104 5.31383 5.98787 5.14166 5.49993H1.66666V3.83326H5.14166ZM7.49999 5.49993C7.721 5.49993 7.93297 5.41213 8.08925 5.25585C8.24553 5.09957 8.33332 4.88761 8.33332 4.66659C8.33332 4.44558 8.24553 4.23362 8.08925 4.07734C7.93297 3.92106 7.721 3.83326 7.49999 3.83326C7.27898 3.83326 7.06701 3.92106 6.91073 4.07734C6.75445 4.23362 6.66666 4.44558 6.66666 4.66659C6.66666 4.88761 6.75445 5.09957 6.91073 5.25585C7.06701 5.41213 7.27898 5.49993 7.49999 5.49993ZM12.5 11.3333C12.721 11.3333 12.933 11.2455 13.0892 11.0892C13.2455 10.9329 13.3333 10.7209 13.3333 10.4999C13.3333 10.2789 13.2455 10.067 13.0892 9.91067C12.933 9.75439 12.721 9.66659 12.5 9.66659C12.279 9.66659 12.067 9.75439 11.9107 9.91067C11.7545 10.067 11.6667 10.2789 11.6667 10.4999C11.6667 10.7209 11.7545 10.9329 11.9107 11.0892C12.067 11.2455 12.279 11.3333 12.5 11.3333ZM7.49999 17.1666C7.721 17.1666 7.93297 17.0788 8.08925 16.9225C8.24553 16.7662 8.33332 16.5543 8.33332 16.3333C8.33332 16.1122 8.24553 15.9003 8.08925 15.744C7.93297 15.5877 7.721 15.4999 7.49999 15.4999C7.27898 15.4999 7.06701 15.5877 6.91073 15.744C6.75445 15.9003 6.66666 16.1122 6.66666 16.3333C6.66666 16.5543 6.75445 16.7662 6.91073 16.9225C7.06701 17.0788 7.27898 17.1666 7.49999 17.1666Z"
                                fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_134_227">
                                <rect width="20" height="20" fill="white" transform="translate(0 0.5)"/>
                            </clipPath>
                        </defs>
                    </svg>
                    {{ $t('Фильтр') }}
                </button>
            </div>
            <div v-if="type === 'rent'" class="period-buttons">
                <div class="period-buttons-from">

                    <p class="period-buttons-title">{{ $t('Получение') }}</p>
                    <div class="header-filter-content">
                        <div class="--city-select">
                            <v-select
                                :reduce="option => option.id"
                                :value="params.from_city"
                                :options="options.city"
                                :selectable="(option) => !option.heading"
                                v-model="params.from_city">
                                <template #option="{ label, tag, heading }">
                                    <span v-if="heading" class="--select-heading">{{ label }}</span>
                                    <span v-else>{{ label }}</span>
                                </template>
                            </v-select>
                        </div>
                        <div class="--date-select">
                            <div class="--date-input">
                                <flat-pickr :config="dateConfig" class="--input" v-model="params.from_date"/>
                            </div>
                        </div>
                        <div class="--time-select">
                            <v-select
                                :searchable="false"
                                :value="params.from_time"
                                :options="options.time"
                                v-model="params.from_time"
                            >
                            </v-select>
                        </div>
                    </div>
                </div>
                <div class="period-buttons-to">

                    <p class="period-buttons-title">{{ $t('Возврат') }}</p>
                    <div class="header-filter-content">
                        <div class="--city-select">
                            <v-select
                                :reduce="option => option.id"
                                :value="params.to_city"
                                :options="options.city"
                                :selectable="(option) => !option.heading"
                                v-model="params.to_city">
                                <template #option="{ label, tag, heading }">
                                    <span v-if="heading" class="--select-heading">{{ label }}</span>
                                    <span v-else>{{ label }}</span>
                                </template>
                            </v-select>
                        </div>
                        <div class="--date-select">
                            <div class="--date-input">
                                <flat-pickr :config="dateConfig" class="--input" v-model="params.to_date"/>
                            </div>
                        </div>
                        <div class="--time-select">
                            <v-select
                                :searchable="false"
                                :value="params.to_time"
                                :options="options.time"
                                v-model="params.to_time"
                            ></v-select>
                        </div>
                    </div>
                </div>
                <button @click="scrollToList"
                        class="--button">{{ $t('Подобрать авто') }}
                </button>
            </div>
            <div v-if="type === 'transfer'" class="transfer-buttons">
                <div class="transfer-buttons-params">
                    <div class="period-buttons-from order-1">

                        <p class="period-buttons-title">{{ $t('Откуда') }}</p>
                        <div class="header-filter-content">
                            <div class="--city-select">
                                <v-select
                                    :reduce="option => option.id"
                                    :value="params.from_city"
                                    :options="options.city"
                                    :selectable="(option) => !option.heading"
                                    v-model="params.from_city">
                                    <template #option="{ label, tag, heading }">
                                        <span v-if="heading" class="--select-heading">{{ label }}</span>
                                        <span v-else>{{ label }}</span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="period-buttons-to order-3 order-md-2">
                        <p class="period-buttons-title">{{ $t('Куда') }}</p>
                        <div class="header-filter-content">
                            <div class="--city-select">
                                <v-select
                                    :reduce="option => option.id"
                                    :value="params.to_city"
                                    :options="options.city"
                                    :selectable="(option) => !option.heading"
                                    v-model="params.to_city">
                                    <template #option="{ label, tag, heading }">
                                        <span v-if="heading" class="--select-heading">{{ label }}</span>
                                        <span v-else>{{ label }}</span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="transfer-buttons-params-date order-2 order-md-3">
                        <div class="--date-select">
                            <div class="--date-input">
                                <flat-pickr :config="dateConfig" class="--input" v-model="params.from_date"/>
                            </div>
                        </div>
                        <div class="--time-select">
                            <v-select
                                :searchable="false"
                                :value="params.from_time"
                                :options="options.time"
                                v-model="params.from_time"
                            ></v-select>
                        </div>
                    </div>
                </div>
                <!--                <button data-bs-toggle="modal" data-bs-target="#registerModal" class="&#45;&#45;button">{{
                                        $t('Забронировать')
                                    }}
                                </button>-->
                <button @click="scrollToList" class="--button">{{
                        $t('Забронировать')
                    }}
                </button>
            </div>
        </div>

        <div v-if="init" class="modal fade filterModal" id="filterModal" tabindex="-1" aria-labelledby="filterModal"
             aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ $t('Фильтры') }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form id="formFilter" class="filter-form">
                            <div class="filter-form-price" v-if="filter.price">
                                <p class="filter-form-title">{{ $t('Цена в сутки') }}</p>
                                <div class="filter-form-inputs">
                                    <div class="filter-form-inputs-from">
                                        <input class="--input" type="text" name="price-from"
                                               :value="filter.price[0]+' €'" @change="changeSlider">
                                        <span class="--input-prefix">{{ $t('от') }}</span>
                                    </div>
                                    <div class="filter-form-inputs-to">
                                        <input class="--input" type="text" name="price-to"
                                               :value="filter.price[1]+' €'" @change="changeSlider">
                                        <span class="--input-prefix">{{ $t('до') }}</span>
                                    </div>
                                </div>
                                <v-nus :config="priceConfig" :id="'priceSlider'" :value="filter.price"
                                       @update="filter.price = $event"></v-nus>
                            </div>
                            <div class="filter-from-gearbox">
                                <p class="filter-form-title">{{ $t("carlist.gearbox") }}</p>
                                <div class="filter-form-inputs">
                                    <div class="--radio-block" v-for="(gear, idx) in options.gearbox">
                                        <input :id="'filter_gear_'+gear.slug" type="radio" name="gearbox"
                                               :value="gear.id" v-model="filter.gearbox">
                                        <label :for="'filter_gear_'+gear.slug" class="--radio-button">
                                            {{ gear.locale }}
                                        </label>
                                    </div>

                                </div>
                            </div>

                            <div class="filter-form-engine" v-if="filter.engine_capacity">
                                <p class="filter-form-title">{{ $t("carlist.engine_capacity") }}</p>
                                <div class="filter-form-inputs">
                                    <div class="filter-form-inputs-from">
                                        <input class="--input" type="text"
                                               :value="parseFloat(filter.engine_capacity[0]).toFixed(1)+''+$t('л')"
                                               name="engine-from"
                                               @change="changeSlider">
                                        <span class="--input-prefix">{{ $t('от') }}</span>
                                    </div>
                                    <div class="filter-form-inputs-to">
                                        <input class="--input" type="text"
                                               :value="parseFloat(filter.engine_capacity[1]).toFixed(1)+''+$t('л')"
                                               name="engine-to"
                                               @change="changeSlider">
                                        <span class="--input-prefix">{{ $t('до') }}</span>
                                    </div>
                                </div>
                                <v-nus :config="engineConfig" :id="'engineSlider'" :value="filter.engine_capacity"
                                       @update="filter.engine_capacity = $event"></v-nus>
                            </div>


                            <div class="filter-from-engine-type">
                                <p class="filter-form-title">{{ $t("carlist.engine") }}</p>
                                <div class="filter-form-inputs">
                                    <div class="--checkbox-block" v-for="(engine, idx) in options.engine">
                                        <input :id="'filter_engine_'+engine.slug" type="checkbox" name="engine_type[]"
                                               :value="engine.id" v-model="filter.engine_type">
                                        <label :for="'filter_engine_'+engine.slug" class="--radio-button">
                                            {{ engine.locale }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="filter-from-passengers-type mt-2">
                                <p class="filter-form-title">{{ $t("carlist.car_capacity") }}</p>
                                <div class="filter-form-inputs">
                                    <div class="--checkbox-block" v-for="(capacity, idx) in options.capacity">
                                        <input type="checkbox"
                                               v-model="filter.capacity"
                                               :id="'filter_capaity_'+capacity.slug" name="passengers[]"
                                               :value="capacity.id">
                                        <label :for="'filter_capaity_'+capacity.slug" class="--radio-button">
                                            {{ capacity.locale }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="resetFilter" class="--button --button-empty"
                                data-bs-dismiss="modal">{{ $t('Сбросить') }}
                        </button>
                        <button type="button" @click="setFilter" class="--button">{{ $t('Применить') }}</button>
                    </div>
                </div>
            </div>
        </div>

        <order-form></order-form>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import OrderForm from "./OrderForm.vue";
import moment from "moment";
import tr from "vue2-datepicker/locale/es/tr";
import de from "vue2-datepicker/locale/es/de";

//import 'flatpickr/dist/flatpickr.css';

export default {
    name: "TypeFilter",
    components: {OrderForm, flatPickr},
    computed: {
        options() {
            return this.$store.state.options;
        },
        dateConfig() {
            return this.$store.state.dateConfig;
        },
        engineConfig() {
            return this.$store.state.engineConfig;
        },
        priceConfig() {
            return this.$store.state.priceConfig;
        },


        init() {
            return this.$store.state.init;
        }
    },
    data() {
        return {

            type: this.$store.state.type,
            params: this.$store.state.params,
            filter: this.$store.state.filter
        }
    },
    mounted() {

    },
    methods: {
        store() {
            return store
        },
        changeType(type) {
            this.type = type;
            this.$store.commit('setType', type);
        },
        setToCity(value) {
            this.params.to_city = value;
        },
        changeSlider(e) {
            let elem = e.target;

            if (elem.getAttribute('name') === 'price-from') {
                this.filter.price[0] = elem.value;
                Vue.set(this.filter.price, 0, elem.value);
            }
            if (elem.getAttribute('name') === 'price-to') {
                this.filter.price[1] = elem.value;
                Vue.set(this.filter.price, 1, elem.value);
            }
            if (elem.getAttribute('name') === 'engine-from') {
                this.filter.engine_capacity[0] = elem.value;
                Vue.set(this.filter.engine_capacity, 0, elem.value);
            }
            if (elem.getAttribute('name') === 'engine-to') {
                this.filter.engine_capacity[1] = elem.value;
                Vue.set(this.filter.engine_capacity, 1, elem.value);
            }
        },
        resetFilter() {
            this.$store.commit('resetFilter');
            this.filter = this.$store.state.filter;
        },
        setFilter() {
            this.filter.active = 1;
            this.$store.commit('setKlass', null);
            this.$store.commit('setFilter', this.filter);
            let modalElem = document.getElementById('filterModal');
            let modelElemInst = bootstrap.Modal.getOrCreateInstance(modalElem);
            modelElemInst.hide();
        },
        scrollToList() {
            let carList = document.getElementById('car-list');
            if (carList)
                carList.scrollIntoView();
        }
    },
    watch: {
        params: {
            handler(val) {
                let params = this.params;

                /*let from = moment(this.params.from_date);
                let to = moment(this.params.to_date);*/

                let from = moment(
                    `${this.params.from_date} ${this.params.from_time}`,
                    'YYYY-MM-DD HH:mm'
                );

                let to = moment(
                    `${this.params.to_date} ${this.params.to_time}`,
                    'YYYY-MM-DD HH:mm'
                );

                // разница в часах
                let total_hours = to.diff(from, 'hours', true);

                let remainder = total_hours % 24;

                // округление вверх до суток
                let total_days = Math.ceil(total_hours / 24);

                // минимум 1 сутки
                if (total_days < 1)
                    total_days = 1;


                params.total_days = total_days;

                if (total_days > 30)
                    params.discount = parseInt(this.options.max_discount);
                else
                    for (let [key, obj] of Object.entries(this.options.discount)) {
                        if (obj.indexOf(total_days) !== -1) {
                            params.discount = parseInt(key);
                        }
                    }

                let delivery = 0;

                let cityFrom = this.options.city.find(city => city.id === params.from_city);

                if (cityFrom !== undefined && typeof cityFrom.delivery !== "undefined")
                    delivery += parseFloat(cityFrom.delivery);

                let cityTo = this.options.city.find(city => city.id === params.to_city);

                if (cityTo !== undefined && typeof cityTo.delivery !== "undefined")
                    delivery += parseFloat(cityTo.delivery);

                params.delivery = delivery;

                this.$store.commit('setParams', params)
            },
            deep: true
        }
    },
    render(createElement, context) {

    }

}
</script>

<style scoped lang="scss">

</style>
